import { Table } from "../../../../_helpers/Table";
import { useNavigate, useOutletContext } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getCategories } from "../../../../_api/Category";
import { Loader } from "../../../../_helpers/components/Forms/Loader";
import { Button } from "../../../../_helpers/components/Button";

const SocioProTab = (props) => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["CATEGORIES"]["features"];
    const [categories, setCategories] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const loadSocioPro = async () => {
        await getCategories().then((resp) => {
            const res = resp.data.map((res) => {
                return {
                    row: [
                        res.name,
                        new Date(res.created_at).toLocaleDateString(),
                    ],
                    data: res,
                };
            });
            setCategories(res);
            setIsLoading(false);
        });
    };

    const rowClick = (value) => {
        navigate(`/company/socio-professional/${value.id}`);
    };

    useEffect(() => {
        loadSocioPro();
    }, []);

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                Catégories socio-professionnelles
                            </h1>
                            <p className="mt-2 text-sm text-gray-600">
                                Gérez les catégories socio-professionnelles de votre entreprise
                            </p>
                        </div>
                        {features_right['add_category'] && (
                            <Button
                                action={() => navigate("/company/socio-professional/create")}
                                name={"Ajouter une catégorie"}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                        <div className="p-6">
                            <Table 
                                headers={["Nom", "Date de création"]}
                                rows={categories} 
                                onClick={rowClick} 
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SocioProTab;
